package net.frozenbit.games.soundgame.theme

import androidx.compose.ui.unit.dp

object Dimensions {
    object Host {
        val smallInnerPadding = 8.dp
        val mediumInnerPadding = 16.dp
        val bigInnerPadding = 32.dp

        val hugeInnerPadding = 64.dp
    }
}
